
<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0688 12.832L14.8414 14.4163M12.0688 12.832L9.29623 14.4163M12.0688 12.832L12.0689 6.49414M14.8414 14.4163V17.1721C14.8414 17.4274 14.7046 17.6631 14.4829 17.7898L12.0688 19.1693M14.8414 14.4163L19.3808 11.4803C19.7142 11.2648 19.8104 10.8125 19.5343 10.5273C19.2795 10.2639 18.9864 10.0336 18.6603 9.8453L14 7.1547C12.7624 6.44017 11.2376 6.44017 10 7.1547L5.33975 9.8453C4.10215 10.5598 3.33975 11.8803 3.33975 13.3094V18.6906C3.33975 20.1197 4.10215 21.4402 5.33975 22.1547L10 24.8453C10.4307 25.094 10.8962 25.2561 11.3722 25.3317C11.7556 25.3925 12.0689 25.0694 12.0689 24.6813L12.0688 19.1693M12.0688 19.1693L9.29623 17.585M9.29623 17.585V14.4163M9.29623 17.585L3.75001 20.7541M9.29623 14.4163L3.75155 11.2481"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M20.396 17.6101L20.1973 17.67L18.137 18.4368L18.0161 18.4879C17.4656 18.7426 17.0936 19.2738 17.0426 19.8783L17.0358 20.0084L17.0209 22.2075L17.0316 22.4138C17.0787 22.8225 17.274 23.2002 17.5797 23.4754L17.7411 23.6036L20.9755 25.8684C21.6921 26.37 22.6625 26.2384 23.2221 25.5902L23.3289 25.4534L25.4049 22.4873C25.94 21.7229 25.7544 20.6701 24.9901 20.1349L21.7557 17.8702L21.58 17.7623C21.2171 17.5693 20.7959 17.515 20.396 17.6101Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.0836 20.25C20.4517 20.2502 20.7496 20.5489 20.7496 20.917C20.7495 21.2849 20.4515 21.5828 20.0836 21.583C19.7155 21.583 19.4168 21.285 19.4166 20.917C19.4166 20.5488 19.7154 20.25 20.0836 20.25Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.5"
    />
  </svg>
</template>
<script>
export default {
  name: 'LensTagsIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>
<style scoped>
</style>
